<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="FMEP"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">… the rhythm will keep me awake, changing.</span></p>
<p class="FMEPC"><b>—ROBERT HASS</b></p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?08a9db70